// extracted by mini-css-extract-plugin
module.exports = {"products--CONTAINER":"ProductsList_products--CONTAINER__1XwqA"};